import React from 'react';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';

interface FeaturedArtistMenuProps {
  activeValue: boolean;
  updateFilter: (filter: 'featured_artist', value: boolean) => void;
}

export const FeaturedArtistMenu: React.FC<FeaturedArtistMenuProps> = ({
  activeValue,
  updateFilter,
}) => (
  <CheckboxField
    label="Only show designs created by our featured artists."
    id="featured-artist-menu"
    type="checkbox"
    checked={activeValue}
    onChange={() => updateFilter('featured_artist', !activeValue)}
    meta={{ touched: true }}
  />
);
